import Form from "../form/Form.js";
import Testimonial from "../testimonial/Testimonial.js";
import Feature from "../features/DataAnalysisFeature.jsx";
import BecomeProfessional from "../becomeprofessional/BecomeProfessional.js";
import TrackTimeline from "../tracksyllabus/TrackTimeline.js";
import "./Main.css";
import LearningEnvironment from "../learningenv/LearnEnvironment.js";
import WhyChooseGeegStack from "../whychoosegeegstack/WhyChooseGeegStack.js";
import CareerSupport from "../careersupport/CareerSupport.js";
import Faq from "../faq/Faq.js";
import Pricing from "../pricing/Pricing.js";
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import whatsAppIcon from "../images/WhatsApp_icon.png";


export default function Main() {
  let track = "Data Analysis";
  let duration = "14 Weeks";
  let content =
    "Whether you have experience working with data before or you are just starting out with no experience, we will hold your hands through and give you all the necessary skill set you need to become a job ready data scientists and data analyst. Within the 16 weeks, you will learn about collecting, cleaning, analysing and presenting data using standard technologies like Excel, Power Bi, Python, SQL & MySQL. You will also work on portfolio projects and learn the strategies to get your first paid job or project as a data analyst and get necessary support";
  let tracks = [
    {
      header: "Fundamentals",
      content:
        "The first few weeks of the program help you get started with working with data and introducing you to data analysis and the tools used to analyse data. You will get started with the Basics of Excel where you'll learn about Data validation, Removing Duplicates, Conditional Formatting, Sorting and Filtering, Find & Replace and Functions.",
    },
    {
      header: "Functions and Pivot Table",
      content:
        "After the basics, we will dive deep into functions in Excel and Pivot Table. You will learn about important FORMULAS AND FUNCTIONS such as References Type, Error Type, Statistical Functions, Counting Functions, Logical Functions, Lookup Functions, Date and Time Functions and Text Functions after which we will apply the functions and formulas learned in DATA CLEANING WITH EXCEL.",
    },
    {
      header: "POWER BI and Data Visualization",
      content:
        "You will be introduced and taken through a deep dive into Power BI, learning important concepts such as shaping and connecting data, creating data model, calculating fields with DAX and data visualization. At this stage you will be given two capstone projects to sharpen your skill.",
    },
    {
      header: "SQL & MySQL",
      content:
        "You will learn comprehensively about SQL - one of the most important languages a data analyst must master - and MySQL. You'll learn about SQL Commands, SQL Components & Coding Style; after which you'll be walked through the Installation and setting up of MYSQL. You will learn about the DATA QUERY LANGUAGE, DATA DEFINITION (DDL), DATA MANIPULATION (DML) etc.",
    },
    {
      header: "Python Programming",
      content:
        "You will then be taken through the World's most popular and most used language - Pyhton and learn how to use it effectively as a data analyst. You'll learn about importing and reading data in Python, Data cleaning and preparation, Data analysis techniques in Python (Pandas library), etc",
    },
  ];
  let faqs = [
    {
      header: "What will I accomplish at the end of the program?",
      content: [
        "At the end of the program, you would acquire the practical skills needed to collect, clean, analyse and report data using standard tools that makes you qualified for a Data Analyst, Data Scientist or Business Analyst roles.",
      ],
    },
    {
      header: "Will I work on projects during the course?",
      content: [
        "Yes, you will certainly work on practical real world projects during the course. Geegstack students work on average of 7 practical projects during the program.",
      ],
    },

    {
      header: "Will Geegstack provide me with a job after the course?",
      content: [
        "We do not guarantee you a job immediately after the course, however, we will give you all the needed insights to secure your first paid job or gig after learning the course and refer you to opportunities when available.",
      ],
    },
    {
      header: "Can I pay in installment?",
      content: [
        "We recommend one time payment for an uninterrupted learning. For installment payment, 60% of the payment has to be made to start the course while the balance is paid before the mid of the course.",
      ],
    },
    {
      header:
        "I don’t have any experience before, can I join the program?",
      content: [
        "Yes, the program is beginner friendly. We are starting from the basics.",
      ],
    },
    {
      header: "What are the tools I need to join the class?",
      content: [
        "You need a PC with a MINIMUM of the following: 4G RAM, 128 HDD/SSD, 2 hours battery lifespan and core i5 processor. All the needed software will be installed for you when the program starts.",
      ],
    },
    {
      header: "I don’t live in Ibadan, how can I join the class?",
      content: [
        "We have a conducive boarding facility for distance students who are interested. You can also consider the self-paced online classes.",
      ],
    },
  ];

  let pricing = [
    {
      header: "Boarding and Internship",
      price: "N400,000",
      duration: "6 months (3 months learning, 3 months Internship)",
      classDays: "Monday - Saturday",
      time: "9am - 6pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    },
    {
      header: "Boarding Only",
      price: "N300,000",
      duration: "12 weeks",
      classDays: "Monday - Saturday",
      time: "9am - 6pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    },

    {
      header: "Week day Classes",
      price: "N195,000",
      duration: " 14 weeks",
      classDays: "Monday - Thursday",
      time: "9am - 2pm",
      Amenities: ["Adequate power supply", "Internet Access"],
    }
  ];
  const [showForm, setShowForm] = useState(false);

  function displayForm() {
    setShowForm(showForm => !showForm);
  }
  
  return (
    <div className="main">
      {showForm &&
      <div style={{
        backgroundColor: "white",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        top: 0,
        left: 0,
        zIndex: 20,
        opacity: 0.95,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <div className="cancel" onClick={() => setShowForm(false)}>
          <span className="bar first_bar"></span>
          <span className="bar third_bar"></span>
          <span className="bar second_bar"></span>
        </div>
        <Form customcss={true} course={"data-analysis"}/>
      </div>
      }
      <a href="https://wa.me/2348050885112" className="ws-icon-link">
        <img src={whatsAppIcon} alt="WhatsApp" width={"50px"} />
      </a>
      <div className="course-info-regis-ctn">
        <div className="overlay"></div>
        <div className="course-info-regis-content">
          <CourseInfo
            courseName="Data Science & Data Analysis Professional Course"
            courseDescription="Acquire the skill sets you need to become a job ready data analyst, data scientist, business analyst or financial analyst even if you're just starting out."
            duration={"16 weeks"}
            startDate={"December 8, 2025"}
            modes={"Weekday, Weekend, Boarding"}
          />
          <Form customcss={true} course={"data-analysis"}/>
        </div>
      </div>
      <Testimonial />
      <Feature track={track} duration={duration} />
      <BecomeProfessional track={"Data Analyst"} content={content} displayForm={displayForm}/>
      <LearningEnvironment displayForm={displayForm}/>
      <TrackTimeline tracks={tracks} displayForm={displayForm}/>
      <WhyChooseGeegStack />
      <CareerSupport track={track}/>
      <div className="get-pack">
        <p>
          Interested in what you'll learn during the course of this program ?
        </p>
        <button onClick={displayForm}>Get Program Package</button>
      </div>
      <Faq faqs={faqs} displayForm={displayForm} />
      <Pricing pricing={pricing} displayForm={displayForm} />
    </div>
  );
}

function CourseInfo({
  courseName,
  courseDescription,
  duration,
  startDate,
  modes
}) {
  return (
    <div className="course_info">
      <div className="coursename">
        <h1 className="course-name">{courseName}</h1>
        <p className="course-description">{courseDescription}</p>
      </div>
      <div className="enrollement-details">
        <div className="enrollement-details-content">
          <h3>Enrollment Details</h3>
          <div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faLocationDot} /> Location
              </p>
              <p style={{textAlign: "right"}}>70/80, Oyo road, Opposite University <br/>of Ibadan Second gate, Ibadan.</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faCalendarDays} /> Start Date
              </p>
              <p>{startDate}</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faClock} /> Duration
              </p>
              <p>{duration}</p>
            </div>
            <div className="enrollement-detail">
              <p>
                <FontAwesomeIcon icon={faCalendar} /> Modes
              </p>
              <p>{modes}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
